<template>
  <div class="patients-block patients">
    <preloader :visible="preloader" />
    <v-server-table ref="vuetable" :url="route" :columns="columns" :options="options" @loading="onLoading" @loaded="onLoaded" class="custom-table-modifier">
      <div v-if="props_data.row.user_info" slot="name" slot-scope="props_data"><a :href="`/patient/${props_data.row.id}/edit`">{{ props_data.row.user_info.name }}</a></div>
      <div v-if="props_data.row.user_info" slot="phones" slot-scope="props_data">
        <span v-for="(phone, index) in props_data.row.user_info.phones" :key="index">{{ phone }}<span v-if="index !== props_data.row.user_info.phones.length - 1">, </span></span>
      </div>
      <div v-if="props_data.row.services" slot="last_updated" slot-scope="props_data" class="table-span-block">
        <span v-for="(service, index) in props_data.row.services" :key="index" class="patient-span">
          <v-popover offset="5" @hide="hideTooltipHandler">
            <span>ECG</span><span> | </span> <span v-if="service.last_updated" :style="{color: getColor(momentDiff(service.last_updated))}"><b>{{ momentFromNow(service.last_updated) }}</b></span> <span v-if="!service.last_updated" style="color:#fb434a"><b>Never</b></span>
            <template slot="popover">
              <div class="tooltip-custom-row"><div>Service: <a :href="'/service/' + service.id">{{ service.id}}</a></div> <a class="mr-2 mb-2 btn btn-sm btn-primary" v-on:click.stop.prevent="copyId(props_data.row.id, service.id)" v-tooltip="{content: 'Copied to clipboard', trigger : 'manual', placement: 'top', show: tooltip.id === service.id && tooltip.row_id === props_data.row.id}">Copy</a></div>
              <div class="tooltip-custom-row" v-if="service.name"><div><a :href="'/service/' + service.id">{{ service.name }}</a></div></div>
              <div class="tooltip-custom-row" v-if="service.device"><div>Device: <span> {{ service.device.serial}}</span></div> <a class="mr-2 mb-2 btn btn-sm btn-primary" v-on:click.stop.prevent="copyId(props_data.row.id, service.device.serial)" v-tooltip="{content: 'Copied to clipboard', trigger : 'manual', placement: 'top', show: tooltip.id === service.device.serial && tooltip.row_id === props_data.row.id}">Copy</a></div>
              <div class="tooltip-custom-row"><a :href="'/service/' + service.id" class="mr-2 mb-2 btn btn-md btn-success" style="margin:auto">View Service</a></div>
            </template>
        </v-popover>
        </span>
      </div>
      <div slot="actions" class="actions-bts" slot-scope="props_data" style="text-align: right; padding-bottom: 5px">
        <a class="mr-2 mb-2 btn btn-sm btn-danger" v-on:click="tryDelete(props_data.row.id)"><i class="icmn-bin" aria-hidden="true"></i></a>
      </div>
    </v-server-table>
  </div>
</template>

<script>
import Preloader from "./blocks/preloader";
export default {
  components: { Preloader },
  props: {
    route: {
      type: String
    },
    dateFormat: {
      type: String,
      default: 'MM-DD-YYYY'
    },
    appUrl: {
      type: String,
    },
    settings: {
      type: String,
    },
    withActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      preloader: false,
      tooltip: {},
      columns: this.withActions ? [ 'name', 'phones', 'last_updated', 'actions' ] : [ 'name', 'phones', 'last_updated' ],
      options: {
        columnsClasses: {
          last_updated: 'ignore-custom-table-modifier'
        },
        filterByColumn: true,
        debounce: 1000,
        requestFunction: (data) => {
          return axios.get(this.route, { params: data });
        },
        dateColumns:['last_updated'],
        dateFormat: this.dateFormat,
        datepickerOptions: {
          showDropdowns: true,
          autoUpdateInput: true,
        },
        orderBy: {
          ascending: false,
        },
        sortable: [],
        filterable: [ 'name', 'phones', 'last_updated' ],
        perPage: 30,
        pagination: {
          chunk: 30,
          dropdown: false
        },
        headings: {
          name: 'Name',
          last_updated: 'Services',
          phones: 'Phones',
          actions: 'Actions',
        },
      }
    }
  },
  methods: {
    hideTooltipHandler() {
      this.tooltip = {}
    },
    copyId(row_id, id) {
      const input = document.createElement('span');
      input.innerHTML = id;
      document.body.appendChild(input);
      const range = document.createRange();
      range.selectNode(input);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      const successful = document.execCommand('copy');
      document.body.removeChild(input)
      if (successful) {
        this.tooltip = { id, row_id }
      }
    },
    momentVue(...args) {
      return moment(...args);
    },
    momentDiff(timestamp) {
      return moment().diff(moment.utc(timestamp), 'minutes');
    },
    momentFromNow(timestamp) {
      return moment.utc(timestamp).fromNow();
    },
    getColor(minutes) {
      const settings = JSON.parse(this.settings);
      let color = null;
      for (const i in settings) {
        if (settings[i].from <= minutes) {
          color = settings[i].color;
        }
      }
      return color;
    },
    onLoading(e) {
      this.preloader = true;
    },
    onLoaded(e) {
      this.preloader = false;
    },

    tryDelete(id) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this document!',
        icon: 'warning',
        confirmButtonText: 'Delete',
        showCloseButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteItem(id);
        }
      });
    },
    deleteItem(id) {
      axios.delete(`/patient/${id}`).then(response => {
        if (response.data.error) {
          this.toast(response.data.error, 'error');
        } else {
          this.toast(response.data.success);
          this.$refs.vuetable.getData()
        }
      }).catch(e => {
        console.log(e);
        this.toast('Can not delete record because of server error.', 'error');
      });
    },

    toast(message, type) {
      const self = this.$swal;
      self.fire({
        text: message,
        icon: type || 'success',
        toast: true,
        showConfirmButton: false,
        position: 'top-end',
        timer: 1500,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', self.stopTimer)
          toast.addEventListener('mouseleave', self.resumeTimer)
        }
      });
    }
  }
}
</script>

<style>
.patients-block .actions-bts > a {
  margin: 2px 0;
}
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip:focus {
  outline: none;
}

.popover {
  max-width: unset;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
  max-width: unset;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(0,0,0, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #c8cfdb;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
.tooltip-custom-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 2px 0;
  min-width: 200px;
}

.tooltip-custom-row .btn {
  margin-left: 5px;
}

.VueTables__limit {
  display: none;
}
</style>
